var render, staticRenderFns
import script from "./init-modal-config.vue?vue&type=script&lang=js"
export * from "./init-modal-config.vue?vue&type=script&lang=js"
import style0 from "./init-modal-config.vue?vue&type=style&index=0&id=6410dcce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports